import { render } from "./simulation.vue?vue&type=template&id=fd4cb96a&scoped=true"
import script from "./simulation.vue?vue&type=script&lang=js"
export * from "./simulation.vue?vue&type=script&lang=js"

import "./simulation.vue?vue&type=style&index=0&id=fd4cb96a&lang=scss&scoped=true"

import exportComponent from "E:\\4-6 项目\\蚂蚁电能交易分析\\energy\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4cb96a"]])

export default __exports__